var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelecounselInactive = function SvgTelecounselInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounsel-/-Sidebars",
    transform: "translate(-314, -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.Templates/01.Side-bar/Expand/Health-screening",
    transform: "translate(296, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(0, 94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Minc-admin-Copy",
    transform: "translate(18, 144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chatbubbles-outline",
    mask: "url(#mask-2)",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeWidth: 1.07691886
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8893983,9.17403207 C12.8557446,9.05287831 12.9297828,8.8846092 13.0004556,8.76345543 C13.0220604,8.72739621 13.0456545,8.69256679 13.0711284,8.65912858 C13.6756363,7.76085558 13.9989885,6.70292826 14,5.62018839 C14.010067,2.51730594 11.391808,0 8.15432072,0 C5.33077409,0 2.97501408,1.92163328 2.42309317,4.47259304 C2.34052574,4.8506863 2.29878039,5.23655003 2.29857442,5.62355378 C2.29857442,8.72980161 4.81587226,11.3144152 8.05335958,11.3144152 C8.56826141,11.3144152 9.26152792,11.1596076 9.64181489,11.0552808 C10.0221019,10.9509539 10.3990235,10.8129732 10.4966192,10.775954 C10.5966613,10.738235 10.7026823,10.7188547 10.8095988,10.7187425 C10.9262536,10.7182959 11.04182,10.7411804 11.1495013,10.7860502 L13.0576669,11.462492 C13.0994918,11.4801978 13.1437321,11.4915415 13.1889164,11.4961458 C13.3376078,11.4961458 13.4581461,11.3756072 13.4581461,11.2269153 C13.4557987,11.1961127 13.4501575,11.1656504 13.4413192,11.1360499 L12.8893983,9.17403207 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.621273302,6.19230338 C-0.278726433,7.80916636 -0.195641815,9.79423201 0.836320537,11.3302325 C0.914060617,11.4476843 0.957810446,11.5385497 0.94434896,11.5994631 C0.930887474,11.6603765 0.542860148,13.6816251 0.542860148,13.6816251 C0.523851715,13.7779642 0.558801869,13.8770114 0.634061714,13.9400864 C0.683366823,13.9793721 0.744674705,14.000521 0.80771488,14 C0.841401941,14.0000828 0.874744192,13.9932081 0.905647188,13.979798 L2.79732247,13.2394139 C2.92751651,13.188086 3.07275576,13.1905067 3.20116704,13.2461446 C3.83856839,13.4945098 4.54327717,13.6499905 5.24832249,13.6499905 C6.19441806,13.6509919 7.12390981,13.4014624 7.94230232,12.9267698"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelecounselInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telecounsel-inactive.c85e7c7b.svg";
export { ForwardRef as ReactComponent };